import fetchAPI from '../../../utils/fetchAPI';

type TParams = {
  xsrfToken: string;
  successUrl?: string;
  accessToken?: string;
  emailNewsletterOptin?: boolean;
  threatMetrix?: Record<string, any>;
  socialNetwork: string;
  recaptchaToken?: string;
};

export default function submitSocialCreateAccount({
  xsrfToken,
  successUrl,
  emailNewsletterOptin,
  threatMetrix,
  accessToken,
  socialNetwork,
  recaptchaToken,
}: TParams): Promise<any> {
  return fetchAPI({
    method: 'POST',
    url: '/identity/v2/api/social/create-account',
    xsrfToken,
    payload: {
      accessToken,
      socialNetwork,
      successUrl,
      emailNewsletterOptin,
      threatMetrix,
      recaptchaToken,
    },
  });
}
